import { User } from '../../../common/types/user';

export const getUserPreferences = (user: User, item: string) => {
  if (!item || !user) return false;

  const preferences = JSON.parse(item);

  return preferences?.[user?.id as number] ?? null;
};

export const setUserPreferences = (user: User, key: string, value: any) => {
  if (!user || !key) return;

  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(new Event('storage'));
};
